/**
 * @generated SignedSource<<f4a1d76106d11af339bfdb2ce2d272cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type accessCheck_softwareReleasesVersionDetail$data = {
  readonly canViewVersionDetailsPage: boolean;
  readonly name: string;
  readonly project: {
    readonly key: string;
  };
  readonly " $fragmentType": "accessCheck_softwareReleasesVersionDetail";
} | null | undefined;
export type accessCheck_softwareReleasesVersionDetail$key = {
  readonly " $data"?: accessCheck_softwareReleasesVersionDetail$data;
  readonly " $fragmentSpreads": FragmentRefs<"accessCheck_softwareReleasesVersionDetail">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "accessCheck_softwareReleasesVersionDetail",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "NONE",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "key"
            },
            "action": "NONE",
            "path": "project.key"
          }
        ]
      },
      "action": "NONE",
      "path": "project"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "canViewVersionDetailsPage"
      },
      "action": "NONE",
      "path": "canViewVersionDetailsPage"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "9b2c4488974a4d13577b85807b03079a";

export default node;
